import {DEFAULT_REQUEST_CONFIG, performRequest} from 'shared/utils/request';

interface IGenerateLinkArgs {
  attachmentId: string | number;
  entityName: string;
}

interface IGenerateLinkArgsWithContentType extends IGenerateLinkArgs {
    contentType: string;
}

export const generateAttachmentLink = ({
    attachmentId,
    entityName,
}: IGenerateLinkArgs) => `${DEFAULT_REQUEST_CONFIG.baseURL}/${entityName}/attachment/${String(attachmentId)}`;

export const generateAttachmentLinkWithContentType = ({
    attachmentId,
    entityName,
    contentType
}: IGenerateLinkArgsWithContentType) => `${DEFAULT_REQUEST_CONFIG.baseURL}/${entityName}/attachment/${String(attachmentId)}?contentType=${contentType}`;

export const generateSignatureLink = ({
    attachmentId,
    entityName,
}: IGenerateLinkArgs) => `${DEFAULT_REQUEST_CONFIG.baseURL}/${entityName}/signature/${String(attachmentId)}`;

export const generateAttorneyLink = ({
    attachmentId,
    entityName,
}: IGenerateLinkArgs) => `${DEFAULT_REQUEST_CONFIG.baseURL}/${entityName}/loa-signature/${String(attachmentId)}`;

export const generateAttachmentUploadLink = (
    docId: number,
) => `${DEFAULT_REQUEST_CONFIG.baseURL}/attachment/upload/${String(docId)}`;

export const generateSignatureUploadLink = (
    attachmentId: number | string,
) => `${DEFAULT_REQUEST_CONFIG.baseURL}/signature/upload/${String(attachmentId)}`;

export const generateAttorneyUploadLink = (
    docId: number,
) => `${DEFAULT_REQUEST_CONFIG.baseURL}/loa-signature/upload/${String(docId)}`;

export const uploadFile = (url: string, file: FormData) => performRequest({
    method: 'POST',
    url,
    headers: {'Content-Type': 'multipart/form-data'},
    data: file,
});

export const deleteFile = (url: string) => performRequest({
    method: 'DELETE',
    url,
});

export const signatureUpload = (files: File, attachmentId: number | string) => {
    const signatureUrl = generateSignatureUploadLink(attachmentId);
    const formData = new FormData();
    formData.append('file', files);
    return uploadFile(signatureUrl, formData);
};

export const attachUpload = (files: File, id: number) => {
    const attachUrl = generateAttachmentUploadLink(id);
    const formData = new FormData();
    formData.append('file', files);
    return uploadFile(attachUrl, formData);
};

export const attorneyUpload = (files: File, attachId: number) => {
    const attorneyUrl = generateAttorneyUploadLink(attachId);
    const formData = new FormData();
    formData.append('file', files);
    return uploadFile(attorneyUrl, formData);
};
